import { AuthUser } from '@app/account/account-api.model';
import { ReportingPermissions } from '@app/account/models/permissions/reporting-permissions.model';

export const reportingMapper = (authUser: AuthUser): ReportingPermissions => ({
  isReportingInAppEnabled:
    authUser.defaultOrgInfo?.settings.enableReportingInApp ?? false,

  canViewReporting: authUser?.canViewReporting ?? false,

  canViewInAppReports:
    (authUser.defaultOrgInfo?.settings.enableReportingInApp &&
      authUser?.canViewReporting) ??
    false,

  canScheduleFTPReports:
    authUser.defaultOrgInfo?.permissions.manageReportingFTPScheduler ?? false,

  canManageInAppReports:
    authUser.defaultOrgInfo?.permissions.manageReportingInApp ?? false,

  canManageReportingTransmitters:
    (authUser.defaultOrgInfo?.permissions.manageReportingInApp &&
      authUser.defaultOrgInfo?.permissions
        .manageReportingTransmitterConfigurations) ??
    false,

  canManageReportingDynamicGroups:
    (authUser.defaultOrgInfo?.permissions.manageReportingInApp &&
      authUser.defaultOrgInfo?.permissions.manageSegments) ??
    false,
});
